module.exports = "/images/vendor/flag-icon-css/flags/4x3/th.svg?76fca72f6d180d3f14a55653b8937b5e";